import {Box} from '@buncha/components/core/view';
import React from 'react';

const UploaderChild = () => {
  return <Box />;
};

export default React.memo(UploaderChild);
